import React from 'react';
import styles from './RevenueTables.module.scss';
import RevenueVendorExpenseTable from './RevenueVendorExpenseTable/RevenueVendorExpenseTable';
import Gstr3BTable from './GSTR3BTable/GSTR3BTable';
import { GstRangeKey } from '../GstOverview/useGstDateRange';

interface RevenueTablesProps {
    tab: string;
    dataSource: any;
    fetchHeadlinePanelData: (isPolling?: boolean) => void;
    rangeKey: GstRangeKey;
    fetchStartDate: string;
    fetchEndDate: string;
    unitDivisor?: number;
}

// rangeKey/fetchStartDate/fetchEndDate are the applied GST "Time Period" range
// (RECUR-27384, owned by useGstDateRange in GstAnalysisPanel) — threaded down
// to both tables so their fetches stay in sync with the toggle/month pickers.
function RevenueTables({
    tab,
    dataSource,
    fetchHeadlinePanelData,
    rangeKey,
    fetchStartDate,
    fetchEndDate,
    unitDivisor = 1,
}: RevenueTablesProps) {
    return (
        <div className={styles.RevenueTables}>
            {tab === 'revenue' && (
                <Gstr3BTable
                    dataSource={dataSource}
                    fetchHeadlinePanelData={fetchHeadlinePanelData}
                    rangeKey={rangeKey}
                    fetchStartDate={fetchStartDate}
                    fetchEndDate={fetchEndDate}
                    unitDivisor={unitDivisor}
                />
            )}
            <RevenueVendorExpenseTable
                tab={tab}
                dataSource={dataSource}
                fetchStartDate={fetchStartDate}
                fetchEndDate={fetchEndDate}
                unitDivisor={unitDivisor}
            />
        </div>
    );
}

export default RevenueTables;
